<template>
  <div class="chart-scene">
    <echarts
      :options="options"
      @over="handleMouseOver"
      @out="handleMouseOut"
      @click="handleClick"
      class="chart-stage"
    ></echarts>
    <div v-show="showTotal" class="total">
      <p class="value">{{total.value}}</p>
      <p class="name">{{total.name}}</p>
    </div>
  </div>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default() {
        return ["#66c676", "#d3d3d3", "#ffd37c", "#ff7c7c", "#4d9bf9"];
      }
    },
    total: {
      type: Object
    },
    dbCilck: {
      type: Boolean,
      default: false
    },
    normalShow: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      chartWidth: "100%",
      showTotal: true
    };
  },
  computed: {
    options() {
      if (this.normalShow) {
        return {
          backgroundColor: "rgb(34, 45, 53, .5)",
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
            backgroundColor: "#2D3F4B",
            borderColor: "#2D3F4B",
            borderWidth: "1",
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          color: this.colors,
          series: [
            //内层圈
            
            {
              name: "",
              type: "pie",
              center: ["50%", "50%"], //圆环图的位置
              radius: ["70%", "88%"], //圆环图的半径大小
              label: {
                normal: {
                  show: false,
                  //  position:'center',
                  //  color:'#000',
                  // formatter: "{a|{a}}{abg|}\n {b|{b}\n}{per|{d}%} | {c}",
                  rich: {
                    a: {
                      color: "#999",
                      align: "center"
                    }
                    // hr: {
                    //   borderColor: "#aaa",
                    //   width: "100%",
                    //   height: 0
                    // }
                  }
                },
                //线上的移入事件
                emphasis: {
                  show: false,
                  textStyle: {
                    fontSize: "12"
                  },
                  // formatter: "{b} \n{c}"
                }
              },
              labelLine: {
                show: false,
                length: 2
              },
              itemStyle: {
                borderColor: '#222a37',
                borderWidth: 0
              },
              data: this.data
            }
          ]
        };
      } else {
        return {
          backgroundColor: "rgb(34, 45, 53, .5)",
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
            backgroundColor: "#2D3F4B",
            borderColor: "#2D3F4B",
            borderWidth: "1",
            textStyle: {
              color: "#000",
              fontSize: 12
            }
          },
          color: this.colors,
          series: [
            //内层圈
            {
              name: "",
              type: "pie",
              center: ["50%", "50%"], //圆环图的位置
              radius: ["70%", "88%"], //圆环图的半径大小
              label: {
                normal: {
                  show: false,
                  position: "center"
                  //  formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{per|{d}%}',
                  //   rich: {
                  //       a: {
                  //           color: '#999',
                  //           align: 'center'
                  //       },
                  //       hr: {
                  //           borderColor: '#aaa',
                  //           width: '100%',
                  //           height: 0
                  //       },
                  //   }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  },
                  formatter: "{b} \n\n{c}"
                }
              },

              data: this.data
            }
          ]
        };
      }
    }
  },

  methods: {
    // 鼠标移入隐藏设备总数
    handleMouseOver() {
      this.showTotal = false;
    },
    // 鼠标移出显示设备总数
    handleMouseOut() {
      this.showTotal = true;
    },
    // 点击状态跳转设备页
    handleClick(param) {
      if (this.dbCilck) {
        return;
      }
      if (this.name=="alarmName") {
        this.$router.push({
          path: "/adminNew/alarm",
          query: {
            status: param.name
          }
        });
      }else if (this.name=="deviceName") {
        this.$router.push({
          path: "/adminNew/device",
          query: {
            status: param.name
          }
        });
      }
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-scene {
  height: 100%;
  width: 100%;
  position: relative;
  .chart-stage {
    height: 100%;
  }
  .total {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 16px;
    color: #EBEBEB;
    .name {
      margin-bottom: 10px;
      color: #ADB9C0;
    }
    .value {
      font-size: 22px;
      font-weight: 400;
    }
  }
}
</style>


